import Lottie from 'lottie-react';
import { useEffect } from 'react';
import styled from 'styled-components';
import { KanoPredictionResult, useKanoPrediction } from '../../ai/useKanoPrediction';
import animationData from '../../animations/test.json';
import { FeatureModel } from '../../interfaces/feature';
import ThemeContainer from '../../theme/components/Container';
import { ThemeHeadline } from '../../theme/components/Headline';
import { theme } from '../../theme/theme';

export interface StepContainerItem3Props {
  features: FeatureModel[];
  productInformation: string;
  onPredictionReady: (result: KanoPredictionResult) => void;
}

export const StepContainerItem3: React.FC<StepContainerItem3Props> = ({ features, productInformation, onPredictionReady }) => {
  const { makePrediction } = useKanoPrediction();

  useEffect(() => {
    const performPrediction = async () => {
      const prediction = await makePrediction(features, productInformation);
      onPredictionReady(prediction);
    };

    performPrediction();
  }, [features, productInformation, makePrediction, onPredictionReady]);

  return (
    <Container>
      <ThemeHeadline variant='h3' title='Unsere KI analysiert Deine Features' />
      <LottieContainer>
        <Lottie animationData={animationData} loop={true} style={{ height: 250 }} />;
      </LottieContainer>
    </Container>
  );
};

const Container = styled(ThemeContainer)`
  gap: ${theme.spacing.l};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  margin: 120px auto;

  @media screen and (max-width: ${theme.responsive.breakpoints.medium}) {
    margin: ${theme.spacing.xl} auto;
    padding: 0 ${theme.spacing.d};
    box-sizing: border-box;
  }
`;

const LottieContainer = styled.div`
  width: 100%;
  height: 500px;
`;
